<div class="container">
  <div class="container__header">
    <div class="container__header__top">
      <h2 data-cy="custom-field-type-select-header">
        {{ selectedType | relatedToTypeTitle: customObjects }} Roles
        <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Change Object">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </h2>
      <div class="container__header__top__actions">
        <mat-form-field>
          <mat-icon matPrefix svgIcon="search"></mat-icon>
          <input matInput placeholder="Search..." [formControl]="searchInput" />
        </mat-form-field>
        <button mat-flat-button data-cy="add-role" color="primary" (click)="addRole()">
          <mat-icon svgIcon="add"></mat-icon> Add Role
        </button>
      </div>
    </div>
    <div class="container__header__bottom">
      <ng-container *ngIf="isLoading$ | async as isLoading">
        <mat-progress-bar mode="indeterminate" [class.visibility-hidden]="!isLoading"></mat-progress-bar
      ></ng-container>
    </div>
  </div>
  <div class="container__content">
    <ng-container>
      <div class="container__content__nav">
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            *ngFor="let relatedToType of relatedToTypes"
            [routerLink]="relatedToType | lowercase"
            (click)="selectedType = relatedToType"
          >
            {{ relatedToType | relatedToTypeTitle: customObjects }}
          </button>
        </mat-menu>
      </div>
      <div class="container__content__fields">
        <router-outlet></router-outlet>
      </div>
    </ng-container>
  </div>
</div>
